package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceNavigation
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.TaskBox
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains
import com.essntl.uikit.theme.esTypography

@Composable
fun EditItineraryServiceNotesTasks(
    itineraryService: ItineraryServiceModel,
    allTasks: State<List<TaskModel>>,
    onEvent: (EditItineraryServiceEvent) -> Unit,
    onNavigation: (EditItineraryServiceNavigation) -> Unit,
) {
    val currentProposalServiceTasks =
        rememberContains(
            allTasks.data.orEmpty(),
            setOf(itineraryService.id),
        ) {
            it.itineraryService?.id ?: ""
        }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 1.spacing),
    ) {
        Text(
            text = "Internal notes",
            style = MaterialTheme.esTypography.p2Medium14,
        )

        EsInput(
            value = itineraryService.internalNotes.orEmpty(),
            onValueChange = {
                onEvent(
                    EditItineraryServiceEvent.UpdateItineraryServiceFields(
                        itineraryService = itineraryService.copy(
                            internalNotes = it,
                        ),
                    ),
                )
            },
            placeholder = "No notes here",
            singleLine = false,
            enabled = true,
            minLines = 1,
            modifier = Modifier
                .fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(3.spacing))

        if (allTasks.isLoading)
            EsSpinner(
                modifier = Modifier.align(Alignment.CenterHorizontally),
            )
        else if (allTasks.isFailure)
            Text(
                text = "Failed to load tasks",
                style = MaterialTheme.esTypography.p2Medium14,
            )
        else if (currentProposalServiceTasks.isEmpty())
            Text(
                text = "No tasks",
                style = MaterialTheme.esTypography.p2Medium14,
            )
        else
            currentProposalServiceTasks.forEach { task ->
                TaskBox(
                    task = task,
                    onDeleteTask = {
                        onEvent(
                            EditItineraryServiceEvent.DeleteTask(
                                task = task,
                            ),
                        )
                    },
                    onEditTask = {
                        onNavigation(
                            EditItineraryServiceNavigation.EditTask(
                                taskId = task.id,
                            ),
                        )
                    },
                    onEditTaskStatus = {
                        onEvent(
                            EditItineraryServiceEvent.EditTaskStatus(
                                taskId = task.id,
                                status = it,
                            ),
                        )
                    },
                    modifier = Modifier.fillMaxWidth(),
                )

                Spacer(modifier = Modifier.height(1.spacing))
            }

        Spacer(modifier = Modifier.height(2.spacing))

        EsLargeSecondaryButton(
            onClick = {
                onNavigation(
                    EditItineraryServiceNavigation.AddItineraryServiceTask(
                        itineraryServiceId = itineraryService.id,
                    ),
                )
            },
            text = "Add task",
            suffixIconRes = EsIcons.Add,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}